import React, { useEffect, useState } from 'react';
import SelectMenu from '../../../../component/common/SelectMenu';
import { PER_PAGE } from '../../../../utils/constants';
import SearchInput from '../../../../component/common/Input/SearchInput';
import Table from '../../../../component/common/Table';
import Pagination from '../../../../component/common/Pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import { errorToast } from '../../../../utils/helper';
import { Api } from '../../../../api';
import B2BOverview from '../B2BOverview';
import HybridRevenueShowcase from '../../../DashboardContent.js/HybridRevenueShowcase';
import moment from 'moment';
import { EyeIcon } from '@heroicons/react/24/outline';
import Topbar from '../../../PulseSurvey/Topbar';
import { businessHubB2BEarningsPageData } from '../../../../utils/pageContent';
import { TableCard } from '../../../../component/common/designSystem';

export const ContractLengthComponent = ({ row }) => {
  const [isIconOpen, setIsIconOpen] = useState(false);
  return (
    <div className={'flex justify-center items-center'} onClick={() => setIsIconOpen(!isIconOpen)}>
      {isIconOpen && (
        <div>
          {Math.ceil(
            moment(new Date(row.contractEndDate)).diff(
              new Date(row.contractStartDate),
              'months',
              true
            )
          )}
        </div>
      )}
      {!isIconOpen ? (
        <EyeIcon className="w-[20px] ml-2 text-shoorah-secondary dark:text-white cursor-pointer" />
      ) : null}
    </div>
  );
};

function BTBEarning({topbarShow = true}) {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [earningList, setEarningList] = useState([]);

  const [companyList, setCompanyList] = useState([]);

  // revenue states
  const [revenueDetailsData, setRevenueDetailsData] = useState(businessHubB2BEarningsPageData.revenueDetailsDefaultData);
  const [revenueFilter, setRevenueFilter] = useState('All');

  const handlePagination = (pageNumber, pageSize, searchKey) => {
    setLoader(true);
    Api.getTransactionData(pageNumber, pageSize, searchKey).then((response) => {
      if (response?.data?.meta?.code === 1) {
        setEarningList(response?.data?.data);
        setCurrentPage(pageNumber);
        setTotalCount(response?.data?.meta?.totalRecords);
        setLoader(false);
      } else if (response?.code === 401) {
        setLoader(false);
        errorToast(response?.message);
      } else if (response?.data?.meta?.code === 0) {
        setCurrentPage(1);
        setEarningList([]);
        setTotalCount(0);
        setLoader(false);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });
  };

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, searchTerm);
  };

  const refreshTable = () => handlePagination(1, selectedPerPage?.value, '');

  useEffect(() => {
    if (searchTerm) {
      let searchParam = searchTerm.trim();
      const delayDebounceFn = setTimeout(() => {
        handlePagination(1, selectedPerPage?.value, searchParam);
      }, 800);

      return () => clearTimeout(delayDebounceFn);
    } else {
      handlePagination(1, 10, '');
    }
  }, [searchTerm]);

  useEffect(() => {
    const apiCall = async () => {
      getCompanyList();
    };

    apiCall();
  }, []);

  useEffect(() => {
    const apiCall = async () => {
      setLoader(true);
      getB2bRevenueDetails();
      setLoader(false);
    };

    apiCall();
  }, [revenueFilter]);

  // handlers

  const getCompanyList = () => {
    Api.getCompanyList('company_name', 1)
      .then((res) => {
        if (res.data?.meta?.code === 1) {
          setCompanyList(res.data?.data);
          setRevenueFilter(res.data?.data?.[0]?._id);
        }
      })
      .catch((err) => { });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setRevenueFilter(value);
    return;
  };

  const getB2bRevenueDetails = () => {
    let payload = '';
    if (revenueFilter) {
      payload = revenueFilter;
    } else if (revenueFilter === 'All') {
      payload = 'All';
    } else {
      payload = 'All';
    }

    Api.getB2BEarningsGraphData(payload)
      .then((res) => {
        if (res.data?.meta?.code === 1) {
          const data = res?.data?.data;
          setRevenueDetailsData([
            { name: businessHubB2BEarningsPageData.revenueDetailsDataOne.name, status: businessHubB2BEarningsPageData.revenueDetailsDataOne.status + data?.totalCompanyUsers || 0 },
            {
              name: businessHubB2BEarningsPageData.revenueDetailsDataTwo.name,
              status: businessHubB2BEarningsPageData.revenueDetailsDataTwo.status + data?.totalCompanyAnnualEarning?.toFixed(2) || 0
            },
            {
              name: businessHubB2BEarningsPageData.revenueDetailsDataThree.name,
              status: businessHubB2BEarningsPageData.revenueDetailsDataThree.status + data?.totalCompanySixMonthEarning?.toFixed(2) || 0
            },
            {
              name: businessHubB2BEarningsPageData.revenueDetailsDataFour.name,
              status: businessHubB2BEarningsPageData.revenueDetailsDataFour.status + data?.totalCompanyMonthlyEarning?.toFixed(2) || 0
            }
          ]);
        }
      })
      .catch((err) => { });
  };

  return (
    <div className="relative lg:mb-[45px]">
      {topbarShow === true && 
      <Topbar title={businessHubB2BEarningsPageData.topbarTitleText} />}
      <B2BOverview title={businessHubB2BEarningsPageData.companyHeading} />

      {/* Revenue */}
      <div className="lg:rounded-2xl rounded-xl border-[1.5px] border-shoorah-borderGray p-4 mt-5 dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder dark:text-white bg-white">
        <div className="text-black dark:text-white text-xl font-medium p-2 mb-4 w-full flex gap-4  lg:flex-row flex-col items-center justify-between">
          <h4>{businessHubB2BEarningsPageData.revenueSectionTitle}</h4>
          <div>
            <select
              className="border text-[#666666] dark:bg-shoorah-darkBgColor w-full dark:border-shoorah-darkBorder dark:text-white rounded-md h-8 px-1"
              // value={graphParam.companyName}
              id="companyName"
              name="companyName"
              onChange={handleChange}
              value={revenueFilter}
            >
              <option value={'All'}>{businessHubB2BEarningsPageData.selectCompanyOptionLabel}</option>
              {companyList.map((e) => (
                <option key={e._id} value={e._id}>
                  {e?.company_name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <HybridRevenueShowcase
          title={businessHubB2BEarningsPageData.revenueSectionTitle}
          data={revenueDetailsData}
          revenueFilter={revenueFilter}
          setRevenueFilter={setRevenueFilter}
        />
      </div>

      {/* Earning Table */}
      <div className="mt-6">
        <div className="sm:flex justify-between">
          <div className="flex">
            <div className="hidden sm:flex mr-3 self-center">
              <span className="self-center text-sm mr-2 text-shoorah-lightBlack dark:text-white">{businessHubB2BEarningsPageData.paginationRateText}</span>
              <div className="w-[80px]">
                <SelectMenu
                  menuList={PER_PAGE}
                  showLabel={false}
                  defaultSelected={selectedPerPage}
                  setSelectedMenu={handlePerPage}
                />
              </div>
            </div>
            <div className="self-center">
              <SearchInput
                id="searchKey"
                name="searchKey"
                type="text"
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={businessHubB2BEarningsPageData.searchPlaceholder}
              />
            </div>
          </div>
          <div className="mt-3 sm:mt-0 flex justify-between"></div>
        </div>
        <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: selectedPerPage?.value,
            onPageChange: (page) => handlePagination(page, selectedPerPage?.value, searchTerm),
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table
            columns={businessHubB2BEarningsPageData.tableColumns}
            data={earningList}
            name={'users_table'}
            bottomBorder={totalCount > selectedPerPage?.value}
            refreshTable={refreshTable}
            loader={loader}
          />
        </TableCard>
      </div>
      
    </div>
  );
}

export default BTBEarning;
